// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"qF-z","smallCardRow":"rF-z","largeCardRow":"sF-z","productSearchRow":"tF-z","curatedRow":"uF-z"};